(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ol-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ol-product-information')) {
    customElements.define('ol-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const pairs = Array.from(this.querySelectorAll('[data-ol-info-tab]')).map(tab => [tab, this.querySelector('[data-ol-info-panel="' + tab.dataset.olInfoTab + '"]')]);
        pairs.forEach(([tab, panel]) => { if (!panel) tab.remove(); });
        const tabs = pairs.filter(pair => pair[1]).map(pair => pair[0]);
        const panels = pairs.filter(pair => pair[1]).map(pair => pair[1]);
        if (!tabs.length) { this.hidden = true; return; }
        this.querySelector('.ol-info-tabs').setAttribute('role', 'tablist');
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].setAttribute('aria-hidden', String(i !== index));
            panels[i].inert = i !== index;
          });
          if (focus) tabs[index].focus({ preventScroll: true });
          const row = tabs[index].parentElement;
          const left = tabs[index].offsetLeft - row.offsetLeft;
          if (left < row.scrollLeft) row.scrollLeft = left;
          else if (left + tabs[index].offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = left + tabs[index].offsetWidth - row.clientWidth;
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[index].id);
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].tabIndex = 0;
          tab.addEventListener('click', event => { event.preventDefault(); activate(index); }, { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else if (event.key === ' ') { event.preventDefault(); activate(index); return; }
            else return;
            event.preventDefault(); activate(next, true);
          }, { signal });
        });
        activate(0);
        this.classList.add('is-enhanced');
        const product = this.closest('[data-ol-product]');
        const variantInput = product?.querySelector('[data-ol-variant]');
        const variantData = product?.querySelector('[data-ol-variants]');
        if (variantInput && variantData) {
          let variants;
          try { variants = JSON.parse(variantData.textContent); } catch { return; }
          const update = () => {
            const variant = variants.find(item => String(item.id) === variantInput.value);
            if (!variant) return;
            this.querySelectorAll('[data-ol-info-option]').forEach(value => { value.textContent = variant.options[Number(value.dataset.olInfoOption)] || ''; });
          };
          variantInput.addEventListener('change', update, { signal });
          update();
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
